/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { profileActivitiesDateHistogram } from '../fn/profile-analytics/profile-activities-date-histogram';
import { ProfileActivitiesDateHistogram$Params } from '../fn/profile-analytics/profile-activities-date-histogram';
import { ProfileAnalyticsCumulativeHistogram } from '../models/profile-analytics-cumulative-histogram';
import { ProfileAnalyticsTermItem } from '../models/profile-analytics-term-item';
import { ProfileAnalyticsUsers } from '../models/profile-analytics-users';
import { profileFollowersDateHistogram } from '../fn/profile-analytics/profile-followers-date-histogram';
import { ProfileFollowersDateHistogram$Params } from '../fn/profile-analytics/profile-followers-date-histogram';
import { profileFollowersTypeHistogram } from '../fn/profile-analytics/profile-followers-type-histogram';
import { ProfileFollowersTypeHistogram$Params } from '../fn/profile-analytics/profile-followers-type-histogram';
import { profilePageviewsDateHistogram } from '../fn/profile-analytics/profile-pageviews-date-histogram';
import { ProfilePageviewsDateHistogram$Params } from '../fn/profile-analytics/profile-pageviews-date-histogram';
import { profileReferralsHistogramDateHistogram } from '../fn/profile-analytics/profile-referrals-histogram-date-histogram';
import { ProfileReferralsHistogramDateHistogram$Params } from '../fn/profile-analytics/profile-referrals-histogram-date-histogram';
import { profileReferralsTypeHistogram } from '../fn/profile-analytics/profile-referrals-type-histogram';
import { ProfileReferralsTypeHistogram$Params } from '../fn/profile-analytics/profile-referrals-type-histogram';
import { profileUsersDateHistogram } from '../fn/profile-analytics/profile-users-date-histogram';
import { ProfileUsersDateHistogram$Params } from '../fn/profile-analytics/profile-users-date-histogram';
import { profileUtmCampaignsDateHistogram } from '../fn/profile-analytics/profile-utm-campaigns-date-histogram';
import { ProfileUtmCampaignsDateHistogram$Params } from '../fn/profile-analytics/profile-utm-campaigns-date-histogram';
import { profileUtmCampaignsTypeHistogram } from '../fn/profile-analytics/profile-utm-campaigns-type-histogram';
import { ProfileUtmCampaignsTypeHistogram$Params } from '../fn/profile-analytics/profile-utm-campaigns-type-histogram';
import { profileWellDoneDateHistogram } from '../fn/profile-analytics/profile-well-done-date-histogram';
import { ProfileWellDoneDateHistogram$Params } from '../fn/profile-analytics/profile-well-done-date-histogram';
import { profileWellDoneTypeHistogram } from '../fn/profile-analytics/profile-well-done-type-histogram';
import { ProfileWellDoneTypeHistogram$Params } from '../fn/profile-analytics/profile-well-done-type-histogram';

@Injectable({ providedIn: 'root' })
export class ProfileAnalyticsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `profileActivitiesDateHistogram()` */
  static readonly ProfileActivitiesDateHistogramPath = '/analytics/profile/{id}/activities';

  /**
   * Get activities analytics for profile - date histogram. All profile activities are aggregated to buckets by years (with summary count of activities for year) and months (with summary count of activities for month).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileActivitiesDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileActivitiesDateHistogram$Response(params: ProfileActivitiesDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
    return profileActivitiesDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get activities analytics for profile - date histogram. All profile activities are aggregated to buckets by years (with summary count of activities for year) and months (with summary count of activities for month).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileActivitiesDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileActivitiesDateHistogram(params: ProfileActivitiesDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsCumulativeHistogram> {
    return this.profileActivitiesDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>): ProfileAnalyticsCumulativeHistogram => r.body)
    );
  }

  /** Path part for operation `profileWellDoneDateHistogram()` */
  static readonly ProfileWellDoneDateHistogramPath = '/analytics/profile/{id}/well-dones';

  /**
   * Get well-dones analytics for profile - date histogram. All new profile Well Done`s are aggregated to buckets by years (with summary count of well done`s for year) and months (with summary count of well done`s for month).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileWellDoneDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileWellDoneDateHistogram$Response(params: ProfileWellDoneDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
    return profileWellDoneDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get well-dones analytics for profile - date histogram. All new profile Well Done`s are aggregated to buckets by years (with summary count of well done`s for year) and months (with summary count of well done`s for month).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileWellDoneDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileWellDoneDateHistogram(params: ProfileWellDoneDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsCumulativeHistogram> {
    return this.profileWellDoneDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>): ProfileAnalyticsCumulativeHistogram => r.body)
    );
  }

  /** Path part for operation `profileWellDoneTypeHistogram()` */
  static readonly ProfileWellDoneTypeHistogramPath = '/analytics/profile/{id}/well-dones/follower-type-histogram';

  /**
   * Get for profile well dones type histogram (for each of following count).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileWellDoneTypeHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileWellDoneTypeHistogram$Response(params: ProfileWellDoneTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
    return profileWellDoneTypeHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get for profile well dones type histogram (for each of following count).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileWellDoneTypeHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileWellDoneTypeHistogram(params: ProfileWellDoneTypeHistogram$Params, context?: HttpContext): Observable<Array<ProfileAnalyticsTermItem>> {
    return this.profileWellDoneTypeHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAnalyticsTermItem>>): Array<ProfileAnalyticsTermItem> => r.body)
    );
  }

  /** Path part for operation `profileFollowersDateHistogram()` */
  static readonly ProfileFollowersDateHistogramPath = '/analytics/profile/{id}/followers';

  /**
   * Get followers analytics for profile - date histogram. All new profile followers are aggregated to buckets by years (with summary count of followers for year) and months (with summary count of followers for month).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileFollowersDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileFollowersDateHistogram$Response(params: ProfileFollowersDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
    return profileFollowersDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get followers analytics for profile - date histogram. All new profile followers are aggregated to buckets by years (with summary count of followers for year) and months (with summary count of followers for month).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileFollowersDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileFollowersDateHistogram(params: ProfileFollowersDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsCumulativeHistogram> {
    return this.profileFollowersDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>): ProfileAnalyticsCumulativeHistogram => r.body)
    );
  }

  /** Path part for operation `profileFollowersTypeHistogram()` */
  static readonly ProfileFollowersTypeHistogramPath = '/analytics/profile/{id}/followers/type-histogram/{type}';

  /**
   * Get for profile followers type histogram (for each of following count).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileFollowersTypeHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileFollowersTypeHistogram$Response(params: ProfileFollowersTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
    return profileFollowersTypeHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get for profile followers type histogram (for each of following count).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileFollowersTypeHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileFollowersTypeHistogram(params: ProfileFollowersTypeHistogram$Params, context?: HttpContext): Observable<Array<ProfileAnalyticsTermItem>> {
    return this.profileFollowersTypeHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAnalyticsTermItem>>): Array<ProfileAnalyticsTermItem> => r.body)
    );
  }

  /** Path part for operation `profilePageviewsDateHistogram()` */
  static readonly ProfilePageviewsDateHistogramPath = '/analytics/profile/{id}/pageviews';

  /**
   * Get pageviews for profile - date histogram. All profile pageviews are aggregated to buckets by years (with summary count of pageviews for year) and months (with summary count of pageviews for month).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profilePageviewsDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profilePageviewsDateHistogram$Response(params: ProfilePageviewsDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
    return profilePageviewsDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get pageviews for profile - date histogram. All profile pageviews are aggregated to buckets by years (with summary count of pageviews for year) and months (with summary count of pageviews for month).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profilePageviewsDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profilePageviewsDateHistogram(params: ProfilePageviewsDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsCumulativeHistogram> {
    return this.profilePageviewsDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>): ProfileAnalyticsCumulativeHistogram => r.body)
    );
  }

  /** Path part for operation `profileUsersDateHistogram()` */
  static readonly ProfileUsersDateHistogramPath = '/analytics/profile/{id}/users';

  /**
   * Get unique users (logged and anonymous) for profile - date histogram. All profile unique users are aggregated to buckets by years (with summary count of nique users for year) and months (with summary count of nique users for month).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileUsersDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileUsersDateHistogram$Response(params: ProfileUsersDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsUsers>> {
    return profileUsersDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get unique users (logged and anonymous) for profile - date histogram. All profile unique users are aggregated to buckets by years (with summary count of nique users for year) and months (with summary count of nique users for month).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileUsersDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileUsersDateHistogram(params: ProfileUsersDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsUsers> {
    return this.profileUsersDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsUsers>): ProfileAnalyticsUsers => r.body)
    );
  }

  /** Path part for operation `profileReferralsTypeHistogram()` */
  static readonly ProfileReferralsTypeHistogramPath = '/analytics/profile/{id}/referrals';

  /**
   * Get profile refarals - type histogram. For each refaral is provided value - count of visits from referal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReferralsTypeHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReferralsTypeHistogram$Response(params: ProfileReferralsTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
    return profileReferralsTypeHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profile refarals - type histogram. For each refaral is provided value - count of visits from referal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReferralsTypeHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReferralsTypeHistogram(params: ProfileReferralsTypeHistogram$Params, context?: HttpContext): Observable<Array<ProfileAnalyticsTermItem>> {
    return this.profileReferralsTypeHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAnalyticsTermItem>>): Array<ProfileAnalyticsTermItem> => r.body)
    );
  }

  /** Path part for operation `profileReferralsHistogramDateHistogram()` */
  static readonly ProfileReferralsHistogramDateHistogramPath = '/analytics/profile/{id}/referrals/histogram';

  /**
   * Get for single profile referral - date histogram. All visits from referral are aggregated to buckets by years (with summary count) and months (with summary count).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReferralsHistogramDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReferralsHistogramDateHistogram$Response(params: ProfileReferralsHistogramDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
    return profileReferralsHistogramDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get for single profile referral - date histogram. All visits from referral are aggregated to buckets by years (with summary count) and months (with summary count).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReferralsHistogramDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReferralsHistogramDateHistogram(params: ProfileReferralsHistogramDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsCumulativeHistogram> {
    return this.profileReferralsHistogramDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>): ProfileAnalyticsCumulativeHistogram => r.body)
    );
  }

  /** Path part for operation `profileUtmCampaignsTypeHistogram()` */
  static readonly ProfileUtmCampaignsTypeHistogramPath = '/analytics/profile/{id}/utm-campaigns/{type}';

  /**
   * Get UTM Campaign analytics - type histogram - for profile by campaign / source or medium.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileUtmCampaignsTypeHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileUtmCampaignsTypeHistogram$Response(params: ProfileUtmCampaignsTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
    return profileUtmCampaignsTypeHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get UTM Campaign analytics - type histogram - for profile by campaign / source or medium.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileUtmCampaignsTypeHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileUtmCampaignsTypeHistogram(params: ProfileUtmCampaignsTypeHistogram$Params, context?: HttpContext): Observable<Array<ProfileAnalyticsTermItem>> {
    return this.profileUtmCampaignsTypeHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileAnalyticsTermItem>>): Array<ProfileAnalyticsTermItem> => r.body)
    );
  }

  /** Path part for operation `profileUtmCampaignsDateHistogram()` */
  static readonly ProfileUtmCampaignsDateHistogramPath = '/analytics/profile/{id}/utm-campaigns/{type}/histogram';

  /**
   * Get for single profile utm campaign - date histogram. All visits from utm campaign are aggregated to buckets by years (with summary count) and months (with summary count).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileUtmCampaignsDateHistogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileUtmCampaignsDateHistogram$Response(params: ProfileUtmCampaignsDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
    return profileUtmCampaignsDateHistogram(this.http, this.rootUrl, params, context);
  }

  /**
   * Get for single profile utm campaign - date histogram. All visits from utm campaign are aggregated to buckets by years (with summary count) and months (with summary count).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileUtmCampaignsDateHistogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileUtmCampaignsDateHistogram(params: ProfileUtmCampaignsDateHistogram$Params, context?: HttpContext): Observable<ProfileAnalyticsCumulativeHistogram> {
    return this.profileUtmCampaignsDateHistogram$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>): ProfileAnalyticsCumulativeHistogram => r.body)
    );
  }

}
